<template>
    <div>
        <v-dialog
            v-model="addBillingRatePeriodDialog"
            persistent
            width="500"
        >
            <template v-slot:activator="{ attrs }">
                <v-btn
                    v-if="modelType==='Add'"
                    class="ma-1 action-btn text-subtitle-2"
                    depressed
                    color="primary"
                    v-bind="attrs"
                    @click="openDialog"
                >
                    <v-icon
                        left
                        class="action-icon"
                    >
                        mdi-plus
                    </v-icon>
                    Add Billing Rate Period
                </v-btn>
                <v-icon
                    v-if="modelType==='Edit'"
                    v-bind="attrs"
                    @click="openDialog"
                >
                    mdi-pencil
                </v-icon>
            </template>
            <v-card id="add_member_code_dialog">
                <v-card-title class="text-h5 lighten-2">
                    <span v-if="modelType === 'Add'">Add Billing Rate Period</span>
                    <span v-if="modelType === 'Edit'">Edit Billing Rate Period</span>
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-form
                        ref="form"
                        v-model="formValid"
                    >
                        <v-row class="mt-5">
                            <v-col
                                cols="12"
                                sm="12"
                                class="py-0"
                            >
                                <v-text-field
                                    v-if="addBillingRatePeriodDialog"
                                    v-model="code"
                                    label="Billing Rate Period Code"
                                    :rules="billingRateCodeRules"
                                    outlined
                                    dense
                                    class="upper-case"
                                    required
                                    @input="normalizeFieldValue('code')"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                class="py-0"
                            >
                                <v-text-field
                                    v-if="addBillingRatePeriodDialog"
                                    v-model="time_from"
                                    label="Time From"
                                    :rules="timeFromRules"
                                    outlined
                                    dense
                                    class="upper-case"
                                    required
                                    @input="normalizeFieldValue('time_from')"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="12"
                                class="py-0"
                            >
                                <v-text-field
                                    v-if="addBillingRatePeriodDialog"
                                    v-model="time_to"
                                    label="Time To"
                                    :rules="timeToRules"
                                    outlined
                                    dense
                                    class="upper-case"
                                    required
                                    @input="normalizeFieldValue('time_to')"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn
                        style="text-transform: none !important;"
                        outlined
                        @click="closedDialog"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        style="text-transform: none !important"
                        depressed
                        color="primary"
                        :disabled="!addBillingRatePeriodDialog || !code || !time_from || !time_to"
                        @click="save"
                    >
                        <span v-if="modelType==='Add'">Add</span>
                        <span v-if="modelType==='Edit'">Update</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ErrorDialog
            :show="showErrorDialog"
            title="Billing Rate Period Error"
            @close-error-dialog="closeErrorDialog"
        >
            <template v-slot:errorMessage>
                <div class="py-4">
                    {{ errorDialogMessage }}
                </div>
            </template>
        </ErrorDialog>
    </div>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import ErrorDialog from '@/components/ErrorDialogs/ErrorDialog.vue';
import { parseTimeSpecification } from '@/utils/time.js';
// import CompanyBillingMixin from '@/mixins/CompanyBillingMixin';
export default {
    components: {
        ErrorDialog,
    },
    // mixins: [
    //     CompanyBillingMixin,
    // ],
    props: {
        billingRatePeriodsDetails: {
            type: Object,
            default: () => {},
        },
        modelType: {
            type: String,
            default: '',
        },
    }, 
    data: () => ({
        addBillingRatePeriodDialog: false,
        code: '',
        time_from: '',
        time_to: '',
        formValid: false,
        showErrorDialog: false,
        errorDialogMessage: '',
        billingRateCodeRules: [
            v => !!v || 'Billing Rate Code is required',           
        ],
        timeFromRules: [
            v => parseTimeSpecification(v).ok ? true : 'Time From must be in HH:MM or am/pm format.',
        ],
        timeToRules: [
            v => parseTimeSpecification(v).ok ? true : 'Time To must be in HH:MM or am/pm format.',
        ],
    }),
    watch: {
        billingRatePeriodsDetails: {
            handler() {
                this.applyBillingRatePeriodsDetails();
            },
            deep: true,
        },
    },
    created() {
        this.resetFormData();        
    },
    mounted() {
        if(this.billingRatePeriodsDetails) {
            this.applyBillingRatePeriodsDetails();
        }
    },
    methods: {
        openDialog(){
            this.addBillingRatePeriodDialog = true;
        },
        closeErrorDialog() {
            this.showErrorDialog = false;
            this.errorDialogMessage = '';
        },
        closedDialog() {
            // this.resetFormData();
            this.addBillingRatePeriodDialog = false;
        },
        showServerError(message) {
            this.errorDialogMessage = message || 'No response from server.';
            this.showErrorDialog = true;
        },
        normalizeUpperCaseValue(value) {
            return typeof value === 'string' ? value.toUpperCase() : '';
        },
        normalizeFieldValue(fieldName) {
            this[fieldName] = this.normalizeUpperCaseValue(this[fieldName]);
        },
        applyBillingRatePeriodsDetails() {
            this.code = this.normalizeUpperCaseValue(this.billingRatePeriodsDetails.code);
            this.time_from = this.normalizeUpperCaseValue(this.billingRatePeriodsDetails.time_from);
            this.time_to = this.normalizeUpperCaseValue(this.billingRatePeriodsDetails.time_to);
        },
        capitalized(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        resetFormData() {
            this.code = '';
            this.time_from = '';
            this.time_to = '';
            this.formValid = false;
            if(this.billingRatePeriodsDetails) {
                this.applyBillingRatePeriodsDetails();
            }
        },
        async save() {
            let response = {};
            this.$refs.form.validate();
            const parsedTimeFrom = parseTimeSpecification(this.time_from);
            const parsedTimeTo = parseTimeSpecification(this.time_to);
            if (!parsedTimeFrom.ok || !parsedTimeTo.ok) {
                return;
            }
            if (!this.formValid) {
                return;
            }

            try {
                if (this.modelType === 'Add') {
                    let data = {
                        code: this.code,
                        time_from: parsedTimeFrom.value,
                        time_to: parsedTimeTo.value,
                    };

                    response = await webtmsBackend.addBillingRatePeriod(data);
                    console.log('addBillingRatePeriod response:', response);
                } else if (this.modelType === 'Edit') {
                    let data = {
                        rowid: this.billingRatePeriodsDetails.rowid,
                        code: this.code,
                        time_from: parsedTimeFrom.value,
                        time_to: parsedTimeTo.value,
                    };
                    response = await webtmsBackend.updateBillingRatePeriod(data);
                    console.log('updateBillingRatePeriod response:', response);
                }
            } catch (error) {
                this.showServerError(error?.response?.data?.err || 'No response from server.');
                return;
            }

            if (!response) {
                this.showServerError('No response from server.');
                return;
            }

            if (response.err) {
                this.showServerError(response.err);
                return;
            }

            if (response?.result?.result === 'ERR') {
                this.showServerError(response?.result?.message || 'No response from server.');
                return;
            }

            if(response?.result?.result === 'OK') {
                this.$store.commit('SET_COMPANY_BILLING_RATE_PERIODS', { rate_periods: response.rate_periods} );
                this.$store.dispatch('setSnackbar', { text: response.result.message, color:'success' });
            } else {
                this.showServerError('No response from server.');
                return;
            }
            this.resetFormData();
            this.addBillingRatePeriodDialog = false;
        }
    },    
};
</script>
<style>
.upper-case input, .upper-case textarea {
    text-transform: uppercase;
}
</style>
